import React, { useState } from "react";
import "./ChatBot.css";
import QuestionAnswerIcon from "@mui/icons-material/QuestionAnswer";
import CloseIcon from "@mui/icons-material/Close";
import Chatbox2 from "./Chatboxcopy";
import logo from '../../../Assets/images/chatbotimages/logo.png'
import { useSearchParams } from 'react-router-dom';
const ChatBot = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [isOpen, setIsOpen] = useState(false);
  const [bgColor, setBgColor] = useState("#724ae8");
  const toggleChat = () => {
    setIsOpen(!isOpen);
    if (!isOpen) {
      setSearchParams({ chatbot: !isOpen });
      setBgColor("#0056b3");
    } else {
      setSearchParams('');
      setBgColor("#724ae8");
    }
  };

  return (
    <>
      <div
        className={`chat-bot ${isOpen ? "chatbot_open" : ""}`}
        // // 
        style={{ backgroundColor: bgColor }}
      >
        <div className="chatbot_icon-container" onClick={toggleChat}>
          <QuestionAnswerIcon className={`chatbot_icon ${isOpen ? "hide" : "show"}`} />
          <CloseIcon className={`chatbot_icon ${isOpen ? "show" : "hide"}`} />
        </div>
        <div className={`chat-box ${isOpen ? "open" : ""}`}>
          <div className="chat-box-div-1">
            <div className="talktotrakky_chatbot"><p className="chat-box-div-1-p">Talk to</p><img src={logo} alt="" className="span_logo_chatbot" /></div>

            <p className="chat-box-div-2-p">Get best salon booking experiance with Trakky</p>
          </div>
          <Chatbox2 />
        </div>
      </div>
    </>
  );
};

export default ChatBot;
